module.exports = __webpack_public_path__ + "static/media/password.0699ba09.png";